import React from "react"

import { prefetchPartnersReferralsListQuery } from "@boundless/bl-api-client/partners/services"
import { createFileRoute, redirect } from "@tanstack/react-router"

import {
  FallbackReferralsTable,
  PartnerReferralsTable,
} from "@/components/partner-referrals/PartnerReferralsTable"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export const Route = createFileRoute("/_dashboard/partners/referrals")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["customer.view_company", "partners.view_partner"])) {
      throw redirect({ to: "/" })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    prefetchPartnersReferralsListQuery(queryClient)
  },
})

function RouteComponent() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Referrals</CardTitle>
        <CardDescription>
          Keep track of your referrals and how their applications are coming
          along all in one place
        </CardDescription>
      </CardHeader>
      <CardContent>
        <React.Suspense fallback={<FallbackReferralsTable />}>
          <PartnerReferralsTable />
        </React.Suspense>
      </CardContent>
    </Card>
  )
}
